import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cookie-policy-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxTabBar = _resolveComponent("PxTabBar")!
  const _component_PxNavbar = _resolveComponent("PxNavbar")!
  const _component_PxFooter = _resolveComponent("PxFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$screen.smDown)
      ? (_openBlock(), _createBlock(_component_PxTabBar, { key: 0 }))
      : (_openBlock(), _createBlock(_component_PxNavbar, { key: 1 })),
    _cache[0] || (_cache[0] = _createElementVNode("article", null, [
      _createElementVNode("header", null, [
        _createElementVNode("h1", null, "Cookie Policy"),
        _createElementVNode("p", { class: "meta" }, [
          _createTextVNode(" Last updated on "),
          _createElementVNode("time", { pubdate: "pubdate" }, "September 17, 2018"),
          _createTextVNode(" . ")
        ])
      ]),
      _createElementVNode("p", null, " A cookie is a small piece of data (text file) that a website – when visited by a user – asks your browser to store on your device in order to remember information about you, such as your language preference or login information. Those cookies are set by us and called first party cookies. We also use third party cookies – which are cookies from a domain different than the domain of the website you are visiting – for our advertising and marketing efforts. "),
      _createElementVNode("p", null, " More specifically, we use cookies and other tracking technologies for the following purposes: "),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, "Assisting you in navigation;"),
        _createElementVNode("li", null, " Assisting in registration to our events, login, and your ability to provide feedback; "),
        _createElementVNode("li", null, "Analyzing your use of our products, services or applications;"),
        _createElementVNode("li", null, "Analyzing your use of our products, services or applications;"),
        _createElementVNode("li", null, " Assisting with our promotional and marketing efforts. (including behavioral advertising) ")
      ]),
      _createElementVNode("p", null, " Below is a detailed list of the cookies we use on our Website. Our Website is scanned with our cookie scanning tool regularly to maintain a list as accurate as possible. We classify cookies in the following categories: "),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, "Strictly Necessary Cookies"),
        _createElementVNode("li", null, "Performance Cookies"),
        _createElementVNode("li", null, "Targeting Cookies")
      ]),
      _createElementVNode("p", null, " You can opt-out of each cookie category (except strictly necessary cookies) by clicking on the “cookie settings” button below: "),
      _createElementVNode("a", { class: "optanon-show-settings" }, "Cookie Settings"),
      _createElementVNode("div", { id: "optanon-cookie-policy" })
    ], -1)),
    _createVNode(_component_PxFooter, { items: _ctx.footerItems }, null, 8, ["items"])
  ]))
}